import Cookie from 'js-cookie';
import { validate as uuidValidate } from 'uuid';

import type * as DstCookies from '../types/index.d.ts';

export const cookies = Object.freeze({
	appInfo: 'DST_APP_INFO',
	dapp: '_dapp',
	gdprConsent: 'DSGVO_ZUSAGE_V1',
	mguid: 'MGUID',
	notTracking: 's_optout',
} as const);

/**
 * Retrieves the GUID value from the MGUID cookie
 * @deprecated use auth.mguid from auth-core package
 * @returns {string|null}
 */
export function getMguidFromCookie(): string | null {
	const mguidCookie = Cookie.get(cookies.mguid);

	if (mguidCookie) {
		const parsedCookie = new URLSearchParams(mguidCookie);
		const GUID = parsedCookie.get('GUID');

		if (
			GUID && uuidValidate(GUID)
		) {
			return GUID;
		}
	}

	return null;
}

/**
 * Get the value of the _dapp cookie and return it as an object
 *
 * @returns {DstCookies.AppCookieObject} object with app name, version and optional labels
 * @see {@link https://derstandard.atlassian.net/wiki/spaces/PD/pages/3480289325/App-Cookies}
 */
export function getDstAppCookie(): DstCookies.AppCookieObject | null {
	const cookie = Cookie.get(cookies.dapp);

	if (!cookie) {
		return null;
	}

	const values = cookie.split('~');
	const name = values[0];
	const version = values[1];
	const { labels, os } = findLabelsInCookie(values[2]);

	return {
		name,
		version,
		labels,
		os,
	};
}

/**
 * Find labels in cookie and map os when found
 *
 * @param {String} str
 * @returns {DstCookies.AppCookieObject} labels
 */
function findLabelsInCookie(str: string | undefined): DstCookies.AppCookieLabels {
	if (str === undefined) {
		return {};
	}
	const values = str.split(':');
	const data = {} as DstCookies.AppCookieObject;

	values.forEach((item) => {
		if (item === 'ios' || item === 'android') {
			data.os = item;
		} else {
			data.labels = data.labels ?? [];
			data.labels.push(item);
		}
	});

	return data;
}
